import api from './base';

export const repositoriesApi = {
  getAll: (token) =>
    api.get('/repositories/', {
      headers: { Authorization: `Token ${token}` },
    }),

  getById: (repoId, token) =>
    api.get(`/repositories/${repoId}`, {
      headers: { Authorization: `Token ${token}` },
    }),

  create: (repoData, token) =>
    api.post('/repositories/', repoData, {
      headers: { Authorization: `Token ${token}` },
    }),

  update: (repoId, repoData, token) =>
    api.put(`/repositories/${repoId}`, repoData, {
      headers: { Authorization: `Token ${token}` },
    }),

  delete: (repoId, token) =>
    api.delete(`/repositories/${repoId}`, {
      headers: { Authorization: `Token ${token}` },
    }),

  getFiles: (repoId, path = '', token) =>
    api.get(`/repositories/${repoId}/files`, {
      params: { path },
      headers: { Authorization: `Token ${token}` },
    }),

  getFileContent: (repoId, filePath, token) =>
    api.get(`/repositories/${repoId}/files/content`, {
      params: { path: filePath },
      headers: { Authorization: `Token ${token}` },
    }),

  createFile: (repoId, filePath, content, token) =>
    api.post(
      `/repositories/${repoId}/files`,
      { path: filePath, content },
      { headers: { Authorization: `Token ${token}` } }
    ),

  updateFile: (repoId, filePath, content, token) =>
    api.put(
      `/repositories/${repoId}/files`,
      { path: filePath, content },
      { headers: { Authorization: `Token ${token}` } }
    ),

  deleteFile: (repoId, filePath, token) =>
    api.delete(`/repositories/${repoId}/files`, {
      params: { path: filePath },
      headers: { Authorization: `Token ${token}` },
    }),

  // Material Repositories
  getMaterialRepositories: (token) =>
    api.get('/aitutor/repositories/', {
      headers: { Authorization: `Token ${token}` }
    }),

  createMaterialRepository: (repoData, token) =>
    api.post('/aitutor/repositories/', repoData, {
      headers: { Authorization: `Token ${token}` }
    }),

  deleteMaterialRepository: (repoId, token) =>
    api.delete(`/aitutor/repositories/${repoId}/`, {
      headers: { Authorization: `Token ${token}` }
    }),

  linkRepositoryToTutor: (tutorId, repoId, token) =>
    api.post(`/aitutor/ai-tutors/${tutorId}/link-repository/`,
      { repository_id: repoId },
      { headers: { Authorization: `Token ${token}` } }
    ),

  unlinkRepositoryFromTutor: (tutorId, repoId, token) =>
    api.post(`/aitutor/ai-tutors/${tutorId}/unlink-repository/`,
      { repository_id: repoId },
      { headers: { Authorization: `Token ${token}` } }
    ),

  uploadRepositoryMaterial: (repoId, fileData, token) =>
    api.post(`/aitutor/repositories/${repoId}/upload/`,
      fileData,
      {
        headers: {
          Authorization: `Token ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    ),
};
